export function levelInfo(levels, n) {
  return (levels || []).find((l) => Number(l.level) === Number(n)) || null;
}

export function levelLabel(levels, n) {
  const info = levelInfo(levels, n);
  return info ? `L${info.level} — ${info.name}` : `L${n}`;
}

export default function LevelMeaning({ levels, level, className = "", testid }) {
  const info = levelInfo(levels, level);
  if (!info || !info.description) return null;
  return (
    <p className={`text-xs text-slate-500 ${className}`} data-testid={testid}>
      {info.description}
    </p>
  );
}
